/**
 * This NEEDS to be a client component, since extensions has a bunch of
 *  class components which can't be rendered on the server.
 */
"use client"
import { getHtml as _getHtml } from "util/tiptap"
import { extensions } from "@/app/components/Editor/extensions"

export const getHtml = (content: string): undefined | string => {
  return _getHtml(content, extensions)
}
